module.exports = __webpack_public_path__ + "img/reason.ac979f45.svg";